(function() {
  function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
      get: v,
      set: s,
      enumerable: true,
      configurable: true
    });
  }
  var $parcel$global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
  var $parcel$modules = {};
  var $parcel$inits = {};
  var parcelRequire = $parcel$global["parcelRequire5f74"];
  if (parcelRequire == null) {
    parcelRequire = function(id) {
      if (id in $parcel$modules) {
        return $parcel$modules[id].exports;
      }
      if (id in $parcel$inits) {
        var init = $parcel$inits[id];
        delete $parcel$inits[id];
        var module = {
          id: id,
          exports: {}
        };
        $parcel$modules[id] = module;
        init.call(module.exports, module, module.exports);
        return module.exports;
      }
      var err = new Error("Cannot find module '" + id + "'");
      err.code = "MODULE_NOT_FOUND";
      throw err;
    };
    parcelRequire.register = function register(id, init) {
      $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire5f74"] = parcelRequire;
  }
  var parcelRegister = parcelRequire.register;
  parcelRegister("6ph3s", function(module, exports) {
    $parcel$export(module.exports, "default", function() {
      return $4aa24e9d49d5ff32$export$2e2bcd8739ae039;
    });
    var $7bS3h = parcelRequire("7bS3h");
    const $4aa24e9d49d5ff32$var$formatPrice = (amount, currencyCode) => {
      const needsCode = [ "USD", "CAD", "AUD", "HKD", "SGD", "NZD", "SEK", "DKK", "NOK", "CHF" ].includes(currencyCode);
      const needsSymbol = [ "USD", "CAD", "AUD", "HKD", "SGD", "NZD" ].includes(currencyCode);
      if (needsCode) {
        const symbol = needsSymbol ? "$" : "";
        const formattedAmount = (0, $7bS3h.default)(amount, "{{amount_no_decimals}}");
        return `${symbol}${formattedAmount} <span class="text-3xs">${currencyCode}</span>`;
      }
      return (0, $7bS3h.default)(amount, Shopify.money_format).replace(/\.00$/, "");
    };
    var $4aa24e9d49d5ff32$export$2e2bcd8739ae039 = $4aa24e9d49d5ff32$var$formatPrice;
  });
  parcelRegister("7bS3h", function(module, exports) {
    $parcel$export(module.exports, "default", function() {
      return $53c37d114b9030f9$export$2e2bcd8739ae039;
    });
    function $53c37d114b9030f9$export$2e2bcd8739ae039(cents, format) {
      let value = "";
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || window.Shopify?.money_format || "${{amount}}";
      const defaultOption = (opt, def) => typeof opt === "undefined" ? def : opt;
      const formatWithDelimiters = (number, precision, thousands, decimal) => {
        const resolvedPrecision = defaultOption(precision, 2);
        const resolvedThousands = defaultOption(thousands, ",");
        const resolvedDecimal = defaultOption(decimal, ".");
        if (isNaN(number) || number == null) return 0;
        const fixed = (number / 100).toFixed(resolvedPrecision);
        const parts = fixed.split(".");
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + resolvedThousands);
        const centsPart = parts[1] ? resolvedDecimal + parts[1] : "";
        return dollars + centsPart;
      };
      let normalized = cents;
      if (typeof normalized === "string") normalized = normalized.replace(".", "");
      const match = formatString.match(placeholderRegex);
      const token = match ? match[1] : "amount";
      switch (token) {
       case "amount":
        value = formatWithDelimiters(normalized, 2);
        break;

       case "amount_no_decimals":
        value = formatWithDelimiters(normalized, 0);
        break;

       case "amount_with_comma_separator":
        value = formatWithDelimiters(normalized, 2, ".", ",");
        break;

       case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(normalized, 0, ".", ",");
        break;

       default:
        value = formatWithDelimiters(normalized, 2);
        break;
      }
      return formatString.replace(placeholderRegex, value).replace(/(\.|,)00$/g, "");
    }
  });
  parcelRegister("9e4lR", function(module, exports) {
    $parcel$export(module.exports, "MODAL_OPEN_REQUEST_EVENT", function() {
      return $6b78cbfbaadac19a$export$3a3ec5884c2bdab0;
    });
    $parcel$export(module.exports, "MODAL_OPENED_EVENT", function() {
      return $6b78cbfbaadac19a$export$16a5d99daeabc70f;
    });
    $parcel$export(module.exports, "MODAL_OPEN_FAILED_EVENT", function() {
      return $6b78cbfbaadac19a$export$3e10ac5c14d1b477;
    });
    $parcel$export(module.exports, "createModalRequestId", function() {
      return $6b78cbfbaadac19a$export$6966a06f04e186a1;
    });
    const $6b78cbfbaadac19a$export$3a3ec5884c2bdab0 = "mbf:modal-open-request";
    const $6b78cbfbaadac19a$export$16a5d99daeabc70f = "mbf:modal-opened";
    const $6b78cbfbaadac19a$export$3e10ac5c14d1b477 = "mbf:modal-open-failed";
    function $6b78cbfbaadac19a$export$6966a06f04e186a1() {
      return window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    }
    function $6b78cbfbaadac19a$export$dee6409cd6d872a1(detail = {}) {
      const {requestId: requestId = null, baseUrl: baseUrl = null, url: url = null, view: view = null, strategy: strategy = null, context: context = null, modalId: modalId = null, source: source = null} = detail;
      return {
        requestId: requestId,
        baseUrl: baseUrl,
        url: url,
        view: view,
        strategy: strategy,
        context: context,
        modalId: modalId,
        sourceType: source?.type || null,
        sourceId: source?.id || null
      };
    }
  });
  parcelRegister("hdTUn", function(module, exports) {
    $parcel$export(module.exports, "getModalOrchestratorReadiness", function() {
      return $c89f04cac0ca9284$export$b6ddc94bcaaa5fb;
    });
    function $c89f04cac0ca9284$var$getModalState() {
      return window.MBF && typeof window.MBF === "object" ? window.MBF : null;
    }
    function $c89f04cac0ca9284$export$b6ddc94bcaaa5fb() {
      const state = $c89f04cac0ca9284$var$getModalState();
      const isInitialised = Boolean(state?.modalOrchestratorInitialised);
      if (isInitialised) return {
        ready: true,
        reason: null
      };
      return {
        ready: false,
        reason: "modal-orchestrator-not-initialized"
      };
    }
  });
  parcelRegister("5SWup", function(module, exports) {
    $parcel$export(module.exports, "isSwymBisAvailable", function() {
      return $448f5dad87ede000$export$cac796225ff578aa;
    });
    $parcel$export(module.exports, "onSwymBisAvailable", function() {
      return $448f5dad87ede000$export$858bae1b764ca9ee;
    });
    $parcel$export(module.exports, "subscribeForBackInStock", function() {
      return $448f5dad87ede000$export$65a9154226ebdd85;
    });
    var $YjNU1 = parcelRequire("YjNU1");
    function $448f5dad87ede000$var$isBisEnabledBySetting() {
      if (typeof window === "undefined") return false;
      return window.MBF?.settings?.enableBackInStock === true;
    }
    function $448f5dad87ede000$var$getRuntime() {
      if (!$448f5dad87ede000$var$isBisEnabledBySetting()) return null;
      return (0, $YjNU1.initSwymBis)();
    }
    const $448f5dad87ede000$export$597311bb5a89b43c = () => {
      const runtime = $448f5dad87ede000$var$getRuntime();
      return runtime ? runtime.ready() : Promise.resolve();
    };
    const $448f5dad87ede000$export$cac796225ff578aa = () => {
      const runtime = $448f5dad87ede000$var$getRuntime();
      return runtime ? runtime.isAvailable() : false;
    };
    const $448f5dad87ede000$export$858bae1b764ca9ee = callback => {
      const runtime = $448f5dad87ede000$var$getRuntime();
      return runtime ? runtime.onAvailable(callback) : () => {};
    };
    const $448f5dad87ede000$export$65a9154226ebdd85 = args => {
      const runtime = $448f5dad87ede000$var$getRuntime();
      if (!runtime) return Promise.reject(new Error("[swym-bis] disabled by theme setting enable_back_in_stock"));
      return runtime.subscribeForBackInStock(args);
    };
  });
  parcelRegister("YjNU1", function(module, exports) {
    $parcel$export(module.exports, "initSwymBis", function() {
      return $0b54f75990233cb1$export$23cdde14ed5ac142;
    });
    const $0b54f75990233cb1$var$ALLOWED_MEDIA = new Set([ "email", "sms" ]);
    const $0b54f75990233cb1$var$REQUIRED_PRODUCT_FIELDS = [ "epi", "empi", "du", "pr", "iu" ];
    const $0b54f75990233cb1$var$BACK_IN_STOCK_TOPIC = "backinstock";
    const $0b54f75990233cb1$var$MAILING_LIST_DISABLED_MESSAGE = "Swym mailing list opt-in is not enabled. Enable the mailing list feature in the Swym dashboard and the theme setting before sending addToMailingList: 1.";
    const $0b54f75990233cb1$var$MAILING_LIST_DISABLED_USER_MESSAGE = "Newsletter opt-in is not available right now. Untick the newsletter box and try again.";
    function $0b54f75990233cb1$var$deferCallback(callback) {
      if (typeof queueMicrotask === "function") {
        queueMicrotask(callback);
        return;
      }
      Promise.resolve().then(callback);
    }
    function $0b54f75990233cb1$var$normalizeSwymSuccessArgs(args) {
      if (!Array.isArray(args) || args.length === 0) return null;
      if (args.length === 1) return args[0];
      return args;
    }
    function $0b54f75990233cb1$var$stringifySwymCallbackValue(value) {
      if (value instanceof Error) return value.message || value.name || "Error";
      if (typeof value === "string") return value.trim() || "empty string";
      if (value === undefined) return "undefined";
      if (value === null) return "null";
      try {
        return JSON.stringify(value);
      } catch (_error) {
        return Object.prototype.toString.call(value);
      }
    }
    function $0b54f75990233cb1$var$getSwymObjectMessage(value) {
      const message = value.message || value.error || value.msg || value.description;
      if (typeof message === "string" && message.trim()) return message.trim();
      if (message && typeof message === "object") return $0b54f75990233cb1$var$stringifySwymCallbackValue(message);
      const responseText = value.responseText || value.response?.text;
      if (typeof responseText === "string" && responseText.trim()) try {
        const parsed = JSON.parse(responseText);
        return $0b54f75990233cb1$var$getSwymObjectMessage(parsed) || $0b54f75990233cb1$var$stringifySwymCallbackValue(parsed);
      } catch (_error) {
        return responseText.trim();
      }
      return "";
    }
    function $0b54f75990233cb1$var$normalizeSwymErrorArgs(args, context = {}) {
      const values = Array.isArray(args) ? args : [ args ];
      const firstDefined = values.find(value => value !== undefined && value !== null);
      const callbackArgs = values.map($0b54f75990233cb1$var$stringifySwymCallbackValue).join(", ");
      const contextDetails = Object.entries(context).filter(([, value]) => value !== undefined && value !== null && value !== "").map(([key, value]) => `${key}: ${$0b54f75990233cb1$var$stringifySwymCallbackValue(value)}`).join(", ");
      const suffixParts = [];
      if (callbackArgs) suffixParts.push(`callback args: ${callbackArgs}`);
      if (contextDetails) suffixParts.push(`request: ${contextDetails}`);
      const withDetails = message => {
        const normalizedMessage = typeof message === "string" && message.trim() ? message.trim() : "subscribeForProductAlert failed";
        const details = suffixParts.length ? ` (${suffixParts.join("; ")})` : "";
        const error = new Error(`[swym-bis] ${normalizedMessage}${details}`);
        error.swymCallbackArgs = values;
        error.swymRequestContext = context;
        return error;
      };
      if (firstDefined instanceof Error) {
        const error = withDetails(firstDefined.message || firstDefined.name);
        error.cause = firstDefined;
        return error;
      }
      if (typeof firstDefined === "string" && firstDefined.trim()) return withDetails(firstDefined);
      if (firstDefined && typeof firstDefined === "object") return withDetails($0b54f75990233cb1$var$getSwymObjectMessage(firstDefined));
      return withDetails();
    }
    function $0b54f75990233cb1$var$assertRuntime() {
      if (typeof window === "undefined") throw new Error("[swym-bis] window is unavailable");
    }
    function $0b54f75990233cb1$var$normalizeAndValidateProduct(product) {
      if (!product || typeof product !== "object") throw new Error("[swym-bis] product must be an object");
      for (const field of $0b54f75990233cb1$var$REQUIRED_PRODUCT_FIELDS) {
        if (!(field in product) || product[field] === null || product[field] === "") throw new Error(`[swym-bis] missing required product field "${field}"`);
      }
      const du = String(product.du).trim().split("#")[0].split("?")[0];
      if (!du) throw new Error("[swym-bis] product.du must be a valid canonical URL");
      return {
        epi: product.epi,
        empi: product.empi,
        du: du,
        pr: product.pr,
        iu: String(product.iu).trim()
      };
    }
    function $0b54f75990233cb1$var$validateMedium(mediumValue, medium) {
      if (!mediumValue || typeof mediumValue !== "string" || mediumValue.trim().length === 0) throw new Error("[swym-bis] mediumValue is required");
      if (!$0b54f75990233cb1$var$ALLOWED_MEDIA.has(medium)) throw new Error('[swym-bis] medium must be either "email" or "sms"');
    }
    function $0b54f75990233cb1$var$isMailingListOptInEnabled() {
      return window.MBF?.settings?.enableBackInStockMailingList === true;
    }
    function $0b54f75990233cb1$var$createSwymBisRuntime() {
      let swatRef = null;
      const availableCallbacks = new Set;
      let readyResolve;
      const readyPromise = new Promise(resolve => {
        readyResolve = resolve;
      });
      const hasBisSubscribeCapability = () => Boolean(swatRef && typeof swatRef.subscribeForProductAlert === "function");
      const setReady = swat => {
        if (!swat || swatRef) return;
        swatRef = swat;
        readyResolve();
        if (!hasBisSubscribeCapability()) return;
        availableCallbacks.forEach(callback => callback());
        availableCallbacks.clear();
      };
      if (window._swat) setReady(window._swat);
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(setReady);
      return {
        ready() {
          return readyPromise;
        },
        isAvailable() {
          return hasBisSubscribeCapability();
        },
        onAvailable(callback) {
          if (typeof callback !== "function") return () => {};
          if (hasBisSubscribeCapability()) {
            callback();
            return () => {};
          }
          availableCallbacks.add(callback);
          return () => availableCallbacks.delete(callback);
        },
        async subscribeForBackInStock({mediumValue: mediumValue, medium: medium = "email", product: product, addToMailingList: addToMailingList = 0} = {}) {
          $0b54f75990233cb1$var$validateMedium(mediumValue, medium);
          const normalizedProduct = $0b54f75990233cb1$var$normalizeAndValidateProduct(product);
          const normalizedAddToMailingList = Number(addToMailingList) === 1 ? 1 : 0;
          if (normalizedAddToMailingList === 1 && !$0b54f75990233cb1$var$isMailingListOptInEnabled()) {
            const error = new Error(`[swym-bis] ${$0b54f75990233cb1$var$MAILING_LIST_DISABLED_MESSAGE}`);
            error.userMessage = $0b54f75990233cb1$var$MAILING_LIST_DISABLED_USER_MESSAGE;
            error.swymRequestContext = {
              medium: medium,
              product: normalizedProduct,
              addToMailingList: normalizedAddToMailingList,
              topic: $0b54f75990233cb1$var$BACK_IN_STOCK_TOPIC
            };
            throw error;
          }
          await readyPromise;
          return new Promise((resolve, reject) => {
            let settled = false;
            const resolveOnce = value => {
              if (settled) return;
              settled = true;
              resolve(value);
            };
            const rejectOnceDeferred = (...errorArgs) => {
              const normalizedError = $0b54f75990233cb1$var$normalizeSwymErrorArgs(errorArgs, {
                medium: medium,
                product: normalizedProduct,
                addToMailingList: normalizedAddToMailingList,
                topic: $0b54f75990233cb1$var$BACK_IN_STOCK_TOPIC
              });
              $0b54f75990233cb1$var$deferCallback(() => {
                if (settled) return;
                settled = true;
                reject(normalizedError);
              });
            };
            swatRef.subscribeForProductAlert(mediumValue.trim(), medium, normalizedProduct, (...successArgs) => resolveOnce($0b54f75990233cb1$var$normalizeSwymSuccessArgs(successArgs)), (...errorArgs) => rejectOnceDeferred(...errorArgs), normalizedAddToMailingList, $0b54f75990233cb1$var$BACK_IN_STOCK_TOPIC);
          });
        }
      };
    }
    function $0b54f75990233cb1$export$23cdde14ed5ac142() {
      $0b54f75990233cb1$var$assertRuntime();
      window.MBF = window.MBF || {};
      if (window.MBF.swymBis) return window.MBF.swymBis;
      const runtime = $0b54f75990233cb1$var$createSwymBisRuntime();
      window.MBF.swymBis = runtime;
      return runtime;
    }
  });
  var $6ph3s = parcelRequire("6ph3s");
  var $9e4lR = parcelRequire("9e4lR");
  var $hdTUn = parcelRequire("hdTUn");
  var $5SWup = parcelRequire("5SWup");
  (() => {
    if (customElements.get("product-form-external")) return;
    customElements.define("product-form-external", class ProductFormExternal extends HTMLElement {
      constructor() {
        super();
        this.formID = this.getAttribute("data-form");
        this.productFormEl = document.querySelector(`product-form[form="${this.formID}"]`);
        this.atcButtonEl = this.querySelector('button[type="submit"]');
        this.priceEls = this.querySelectorAll("[data-price]");
        this.compareAtPriceEls = this.querySelectorAll("[data-compare-at-price]");
        this.handleChange = this._handleChange.bind(this);
        this.handleDisabledClick = this._handleDisabledClick.bind(this);
        this.handleNotifyClick = this._handleNotifyClick.bind(this);
        this.handleSwymAvailable = this._handleSwymAvailable.bind(this);
        this.swymAvailabilityUnsubscribe = null;
      }
      connectedCallback() {
        if (!this.productFormEl || !this.atcButtonEl) {
          console.warn("[ProductFormExternal] Missing required elements, component disabled.", {
            formID: this.formID
          });
          return;
        }
        this.productFormEl.addEventListener("variant:change", this.handleChange);
        this.swymAvailabilityUnsubscribe = (0, $5SWup.onSwymBisAvailable)(this.handleSwymAvailable);
        this._updateVariantState(this.productFormEl.currentVariant);
      }
      disconnectedCallback() {
        this.productFormEl?.removeEventListener("variant:change", this.handleChange);
        this.atcButtonEl?.removeEventListener("click", this.handleDisabledClick);
        this.atcButtonEl?.removeEventListener("click", this.handleNotifyClick);
        this.swymAvailabilityUnsubscribe?.();
        this.swymAvailabilityUnsubscribe = null;
      }
      _handleChange(event) {
        this._updateVariantState(event.detail?.variant);
      }
      _updateVariantState(variant) {
        this.currentVariant = variant;
        this._updatePrice();
        this._updateButton();
      }
      _updateButton() {
        const variant = this.currentVariant;
        const isAvailable = variant?.available;
        const isSoldOut = variant && !isAvailable;
        const useNotifyCta = Boolean(isSoldOut && (0, $5SWup.isSwymBisAvailable)());
        const isDisabled = useNotifyCta ? false : !isAvailable;
        let buttonText;
        if (useNotifyCta) buttonText = window.MBF?.strings?.outOfStock?.notifyLong || "Translation missing: en.product.out_of_stock.notify_long"; else if (isAvailable) buttonText = window.MBF?.strings?.addToCart || "Translation missing: en.product.add_to_cart"; else if (isSoldOut) buttonText = window.MBF?.strings?.soldOut || "Translation missing: en.product.sold_out"; else buttonText = window.MBF?.strings?.selectOptions || "Translation missing: en.product.select_options";
        const innerTextEl = this.atcButtonEl.querySelector("[data-atc-text]");
        if (innerTextEl) innerTextEl.textContent = buttonText; else this.atcButtonEl.textContent = buttonText;
        this.atcButtonEl.disabled = isDisabled;
        this.atcButtonEl.classList.toggle("btn--primary", !isDisabled);
        this.atcButtonEl.classList.toggle("btn--secondary", isDisabled);
        const innerPriceEl = this.atcButtonEl.querySelector("[data-atc-price]");
        innerPriceEl?.classList.toggle("hidden", isDisabled);
        innerPriceEl?.classList.toggle("flex", !isDisabled);
        this.atcButtonEl.removeEventListener("click", this.handleDisabledClick);
        this.atcButtonEl.removeEventListener("click", this.handleNotifyClick);
        if (useNotifyCta) {
          this.atcButtonEl.addEventListener("click", this.handleNotifyClick);
          return;
        }
        if (isDisabled) this.atcButtonEl.addEventListener("click", this.handleDisabledClick);
      }
      _updatePrice() {
        const variant = this.currentVariant;
        const price = variant?.price ?? 0;
        const compareAtPrice = variant?.compare_at_price ?? 0;
        const onSale = compareAtPrice > price;
        this.priceEls.forEach(el => {
          el.innerHTML = (0, $6ph3s.default)(price, window.Shopify.currency.active);
        });
        this.compareAtPriceEls.forEach(el => {
          el.innerHTML = onSale ? (0, $6ph3s.default)(compareAtPrice, window.Shopify.currency.active) : "";
        });
      }
      _handleDisabledClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.productFormEl.querySelector(".product-form__option")?.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }
      _handleNotifyClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this._openNotifyDrawer();
      }
      _handleSwymAvailable() {
        if (!this.isConnected || !this.currentVariant || this.currentVariant.available) return;
        this._updateButton();
      }
      _openNotifyDrawer() {
        const variantId = this.currentVariant?.id;
        const baseUrl = this.productFormEl?.dataset?.url;
        if (!variantId || !baseUrl) return;
        const readiness = (0, $hdTUn.getModalOrchestratorReadiness)();
        if (!readiness.ready) {
          console.error("[product-form-external] Cannot open notify drawer", {
            variantId: variantId,
            baseUrl: baseUrl,
            reason: readiness.reason
          });
          return;
        }
        window.dispatchEvent(new CustomEvent((0, $9e4lR.MODAL_OPEN_REQUEST_EVENT), {
          detail: {
            baseUrl: baseUrl,
            view: "notify-drawer",
            params: {
              variant: variantId
            },
            strategy: "stack",
            context: "product-form-external",
            source: {
              type: "product-form",
              id: this.formID || null,
              formId: this.formID || null,
              productId: this.productFormEl?.dataset?.productId || null,
              context: "product-form-external"
            }
          }
        }));
      }
    });
  })();
})();